import axiosInstance from './axios';

// Crash Data APIs
export const getCrashData = ({ lat, lng, distance, startDate, endDate, page, limit }) =>
    axiosInstance.get('/crash-data', { params: { lat, lng, distance, startDate, endDate, page, limit } });

export const getCrashDataById = (id) => axiosInstance.get(`/crash-data/${id}`);

export const createCrashData = ({ timestamp, location, description }) =>
    axiosInstance.post('/crash-data', { timestamp, location, description });

export const updateCrashData = (id, { timestamp, location, description }) =>
    axiosInstance.put(`/crash-data/${id}`, { timestamp, location, description });

export const deleteCrashData = (id) => axiosInstance.delete(`/crash-data/${id}`);

// Incident APIs
export const getIncidents = ({ page=1, limit=10 }) => {
    return axiosInstance.get('/incidents', {
      params: { page, limit },
    });
  };
  

export const getIncidentById = (id) => axiosInstance.get(`/incidents/${id}`);

export const createIncident = ({ sourceType, sourceId, cameraFeedUrl, workflowId }) =>
    axiosInstance.post('/incidents', { sourceType, sourceId, cameraFeedUrl, workflowId });

export const updateIncident = (id, { sourceType, sourceId, cameraFeedUrl, workflowId }) =>
    axiosInstance.put(`/incidents/${id}`, { sourceType, sourceId, cameraFeedUrl, workflowId });

export const deleteIncident = (id) => axiosInstance.delete(`/incidents/${id}`);

export const searchIncidents = ({ startDate, endDate, page, limit, sourceType, sourceId, workflowId }) =>
    axiosInstance.get('/incidents/search', {
        params: { startDate, endDate, page, limit, sourceType, sourceId, workflowId },
    });

// Action APIs
export const getActions = ({ page, limit, search }) =>
    axiosInstance.get('/actions', { params: { page, limit, search } });

export const createAction = ({ name, type, details }) =>
    axiosInstance.post('/actions', { name, type, details });

export const updateAction = (id, { name, type, details }) =>
    axiosInstance.put(`/actions/${id}`, { name, type, details });

// Event APIs
export const getEvents = ({ page, limit, search }) =>
    axiosInstance.get('/events', { params: { page, limit, search } });

export const createEvent = ({ type, description }) =>
    axiosInstance.post('/events', { type, description });

// Workflow APIs
export const getWorkflows = ({ page, limit, search , assetId}) =>
    axiosInstance.get('/workflows', { params: { page, limit, search, assetId } });

export const getWorkflowById = (id) =>
    axiosInstance.get(`/workflows/${id}`);

export const createWorkflow = ({ name, description, type, assetType, assets, events, actions }) =>
    axiosInstance.post('/workflows', {
        name,
        description,
        type,
        ...(type === 'global' ? { assetType } : {}),
        ...(type === 'local' ? { assets } : {}),
        events,
        actions,
    });


export const updateWorkflow = (id, { name, description, cameras, signals, events, actions }) =>
    axiosInstance.put(`/workflows/${id}`, { name, description, cameras, signals, events, actions });

export const deleteWorkflow = (id) => axiosInstance.delete(`/workflows/${id}`);

// Asset APIs
export const getAssets = () => axiosInstance.get('/assets');

export const updateAssetStatus = ({ type, id, status }) =>
    axiosInstance.put('/assets/status', { type, id, status });

export const getTrafficCameras = ({ searchTerm, page, limit }) =>
    axiosInstance.get('/traffic-cameras', { params: { searchTerm, page, limit } });

export const getNearestTrafficCameras = ({ longitude, latitude, maxDistance, limit }) =>
    axiosInstance.get('/traffic-cameras/nearest', {
        params: { longitude, latitude, maxDistance, limit },
    });

export const getTrafficCameraById = (id) =>
    axiosInstance.get(`/traffic-cameras/${id}`);

// Traffic Signal APIs
export const getTrafficSignals = ({ searchTerm, page, limit }) =>
    axiosInstance.get('/traffic-signals', { params: { searchTerm, page, limit } });

export const getNearestTrafficSignals = ({ longitude, latitude, maxDistance, limit }) =>
    axiosInstance.get('/traffic-signals/nearest', {
        params: { longitude, latitude, maxDistance, limit },
    });

export const getTrafficSignalsById = (id) =>
    axiosInstance.get(`/traffic-signals/${id}`);

// Speed Detector APIs
export const getSpeedDetectors = ({ search, page, limit }) =>
    axiosInstance.get('/speed-detectors', { params: { search, page, limit } });

export const updateSpeedDetector = ({ id, status }) =>
    axiosInstance.put(`/speed-detectors/${id}`, { status });

export const getSpeedDetectorById = (id) =>
    axiosInstance.get(`/speed-detectors/${id}`);

// Traffic Message Board APIs
export const getTrafficMessageBoards = ({ search, page, limit }) =>
    axiosInstance.get('/traffic-message-boards', { params: { search, page, limit } });

export const getNearestTrafficMessageBoards = ({ longitude, latitude, maxDistance, page, limit }) =>
    axiosInstance.get('/traffic-message-boards/nearest', {
        params: { longitude, latitude, maxDistance, page, limit },
    });

export const updateTrafficMessageBoard = ({ id, status }) =>
    axiosInstance.put(`/traffic-message-boards/${id}`, { status });

export const getTrafficMessageBoardById = (id) =>
    axiosInstance.get(`/traffic-message-boards/${id}`);

export const getUsers = ({ page = 1, limit = 10 }) =>
    axiosInstance.get('/users', { params: { page, limit } });

// Create a new user
export const createUser = ({
    username,
    email,
    password,
    roles,
    organization,
    firstName,
    lastName,
    phone,
    address,
    status = 'active',
}) =>
    axiosInstance.post('/users', {
        username,
        email,
        password,
        roles,
        organization,
        firstName,
        lastName,
        phone,
        address,
        status,
    });

// Get a user by ID
export const getUserById = (userId) =>
    axiosInstance.get(`/users/${userId}`);

// Update an existing user
export const updateUser = (userId, updateData) =>
    axiosInstance.put(`/users/${userId}`, updateData);


export const getRoles = ({ page = 1, limit = 10 }) =>
    axiosInstance.get('/roles', { params: { page, limit } });

export const createRole = ({ name, permissions }) =>
    axiosInstance.post('/roles', { name, permissions });

export const getOrganizations = ({ page = 1, limit = 10 }) =>
    axiosInstance.get('/organizations', { params: { page, limit } });

export const createOrganization = ({ name, description, contactEmail, contactPhone, address, industry }) =>
    axiosInstance.post('/organizations', { name, description, contactEmail, contactPhone, address, industry });


// Auth APIs
export const login = ({ email, password }) =>
    axiosInstance.post('/login', { email, password });

export const verifyToken = ( token ) =>
    axiosInstance.post('/verify-token', { token });

export const switchApp = ({ userId, appId }) =>
    axiosInstance.post('/switch-app', { userId, appId });


export const getIOTSensors = () =>
    axiosInstance.get('/iot-sensors');

export const getIOTDetections = () =>
    axiosInstance.get('/iot-detections');


// Get all Apps
export const getAllApps = () => axiosInstance.get("/apps");

// Get a single App by ID
export const getAppById = (appId) => axiosInstance.get(`/apps/${appId}`);

// Create a new App
export const createApp = (appData) => axiosInstance.post("/apps", appData);

// Delete an App by ID
export const deleteAppById = (appId) => axiosInstance.delete(`/apps/${appId}`);

export const updateAppById = (appId, appData) => axiosInstance.put(`/apps/${appId}`, appData);


/**
 * Create a new entity
 * @param {Object} entityData - The data for the new entity
 * @returns {Promise} - Axios promise for the POST request
 */
export const createEntity = (entityData) => 
    axiosInstance.post('/entities', entityData);
  
  /**
   * Get all entities with optional pagination
   * @param {Object} params - Query parameters (e.g., page, limit, appId)
   * @returns {Promise} - Axios promise for the GET request
   */
  export const getAllEntities = (params = {}) => 
    axiosInstance.get('/entities', { params });
  
  /**
   * Get an entity by ID
   * @param {string} entityId - The ID of the entity to retrieve
   * @returns {Promise} - Axios promise for the GET request
   */
  export const getEntityById = (entityId) => 
    axiosInstance.get(`/entities/${entityId}`);
  
  /**
   * Update an entity by ID
   * @param {string} entityId - The ID of the entity to update
   * @param {Object} entityData - The updated data for the entity
   * @returns {Promise} - Axios promise for the PUT request
   */
  export const updateEntityById = (entityId, entityData) => 
    axiosInstance.put(`/entities/${entityId}`, entityData);
  
  /**
   * Delete an entity by ID
   * @param {string} entityId - The ID of the entity to delete
   * @returns {Promise} - Axios promise for the DELETE request
   */
  export const deleteEntityById = (entityId) => 
    axiosInstance.delete(`/entities/${entityId}`);
  
  /**
   * Find entities near a specific location
   * @param {Object} params - Query parameters (longitude, latitude, maxDistance, page, limit)
   * @returns {Promise} - Axios promise for the GET request
   */
  export const findEntitiesNear = (params = {}) => 
    axiosInstance.get('/entities/near', { params });

  export const getEntitiesByAppId = (appId, params = {}) => 
    axiosInstance.get(`/entities`, { params: { ...params, appId } });
